module.exports = __webpack_public_path__ + "static/media/hab1-0.87060333.jpg";